/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from 'react';
import useSWR from 'swr';
import clsx from 'clsx';
import { navigate } from 'gatsby-link';
import { AlignJustify } from 'lucide-react';
import PropTypes from 'prop-types';
import SmallScreenNav from '../../new-glu-components/small-screen-nav';
import { CallUs } from '../../../atoms/call-us';
import { sendTrackingData } from '../../../../utils';

const GluSearchBar = ({
	siteSettings,
	mobileOnlyHamburger,
	gluLayout,
	pageName,
}) => {
	const [searchValue, setSearchValue] = useState('');
	const searchRef = useRef(null);

	const handleSearch = () => {
		if (searchValue.trim()) {
			navigate(
				`/elearning/search-results?query=${encodeURIComponent(
					searchValue.trim()
				)}`
			);
		}
	};
	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			handleSearch(); // Trigger search on Enter key press
		}
	};
	const currentDate = new Date().toLocaleDateString('en-UK', {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	});
	const getGreetingMessage = () => {
		const currentHour = new Date().getHours();
		if (currentHour < 12) {
			return 'Good Morning';
		}
		if (currentHour < 18) {
			return 'Good Afternoon';
		}
		return 'Good Evening';
	};
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const toggleMenu = () => {
		setIsMenuOpen(!isMenuOpen);
		if (!isMenuOpen) {
			setSearchValue('');
			// setShowResults(false);
			setTimeout(() => searchRef.current?.focus(), 0);
		}
	};
	const [isMobile, setIsmobile] = useState(false);
	const [width, setWidth] = useState(
		typeof window !== 'undefined' ? window.innerWidth : 0
	);

	useEffect(() => {
		const handleResize = () => {
			setWidth(window.innerWidth);
		};

		if (typeof window !== 'undefined') {
			window.addEventListener('resize', handleResize);
		}

		return () => {
			if (typeof window !== 'undefined') {
				window.removeEventListener('resize', handleResize);
			}
		};
	}, []);

	useEffect(() => {
		if (width < 1024) {
			setIsmobile(true);
		} else {
			setIsmobile(false);
		}
	}, [width]);
	const handleMouseEnter = () => {
		navigate('/elearning/');
	};
	useEffect(() => {
		const handleOutsideClick = (event) => {
			if (isMenuOpen && !event.target.closest('.menu-container')) {
				setIsMenuOpen(false);
			}
		};

		document.addEventListener('click', handleOutsideClick);

		return () => {
			document.removeEventListener('click', handleOutsideClick);
		};
	}, [isMenuOpen]);
	const handleClickTracking = (trackData) => {
		const gtmStartedEvent = window.dataLayer?.find(
			(element) => element['gtm.start']
		);
		if (!gtmStartedEvent) return;

		sendTrackingData('click', trackData);
	};

	const callUsMobileWidth = 768;
	const callUsMobile = width > callUsMobileWidth;

	return (
		<div>
			<form className="flex mb-2 bg-white fixed top-0 z-20 px-5 pt-2 w-full ">
				<div className="glulg:hidden block  w-fit">
					<button
						type="button"
						onClick={toggleMenu}
						className="text-black justify-center mt-5 text-5xl items-center focus:outline-none mr-4"
					>
						<AlignJustify className="w-8 h-8" />
					</button>
				</div>
				<div className="relative  gluxs:w-full mt-5 mb-9 glumd:w-2/4 glulg:w-2/4 glulgx:w-1/3 w-full">
					<input
						id="search"
						name="search"
						ref={searchRef}
						onClick={handleSearch}
						aria-required="true"
						placeholder="Search courses..."
						onKeyDown={handleKeyDown}
						onChange={(e) => {
							setSearchValue(e.target.value);
							// setShowResults(false);
						}}
						onFocus={() => setIsMenuOpen(true)}
						value={searchValue}
						type="text"
						className="rounded-sm border-2 border-blue-500  bg-white px-16 py-2.5 font-lexend-light text-base-f leading-none placeholder:text-grey-500 placeholder:text-lg  focus:!border-black outline-none focus:ring-0 w-full wrapper-small [&>input]:pr-[100px] md:[&>input]:pr-[100px]"
					/>
					<button
						type="button"
						onClick={handleSearch}
						className={clsx(
							' absolute leading-[1.46rem] md:leading-[1.61rem] left-[-2px]',
							'bg-brand-blue-400   rounded-sm'
						)}
					>
						<svg
							height="47.5px"
							id="Layer_1"
							version="1.1"
							viewBox="-200 -190 912 912"
							width="48px"
							xmlSpace="preserve"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M344.5,298c15-23.6,23.8-51.6,23.8-81.7c0-84.1-68.1-152.3-152.1-152.3C132.1,64,64,132.2,64,216.3  c0,84.1,68.1,152.3,152.1,152.3c30.5,0,58.9-9,82.7-24.4l6.9-4.8L414.3,448l33.7-34.3L339.5,305.1L344.5,298z M301.4,131.2  c22.7,22.7,35.2,52.9,35.2,85c0,32.1-12.5,62.3-35.2,85c-22.7,22.7-52.9,35.2-85,35.2c-32.1,0-62.3-12.5-85-35.2  c-22.7-22.7-35.2-52.9-35.2-85c0-32.1,12.5-62.3,35.2-85c22.7-22.7,52.9-35.2,85-35.2C248.5,96,278.7,108.5,301.4,131.2z"
								fill="white"
							/>
						</svg>
					</button>
				</div>
				{callUsMobile && (
					<div className="mt-5 max-w-m-screen mx-auto">
						<CallUs
							callFrom={
								gluLayout || pageName === 'PeninsulaNow'
									? 'page'
									: 'header'
							}
							pageName={pageName}
							number={siteSettings.phoneNumber}
							className={`pr-2 mr-2 text-right ${
								!mobileOnlyHamburger ? '' : 'lg:border-none'
							} md:mr-6 md:pr-6 border-r border-brand-pale-500 focus:outline-0 focus:shadow-focus focus:rounded-xs`}
							onClickProp={() =>
								handleClickTracking({
									event_name: 'navigation',
									click_type: 'tel',
								})
							}
						/>
					</div>
				)}
			</form>
			<SmallScreenNav
				isMobile={isMobile}
				toggleMenu={toggleMenu}
				isMenuOpen={isMenuOpen}
				handleMouseEnter={handleMouseEnter}
			/>
		</div>
	);
};

export default GluSearchBar;

GluSearchBar.defaultProps = {
	siteSettings: {},
	gluLayout: false,
	pageName: null,
	mobileOnlyHamburger: false,
};

GluSearchBar.propTypes = {
	siteSettings: PropTypes.objectOf(PropTypes.string),
	gluLayout: PropTypes.bool,
	mobileOnlyHamburger: PropTypes.bool,
	pageName: PropTypes.string,
};
